import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
export default class LanguageService {
  private client: BaseHttpClient;
  constructor(public controller: string = "languages") {
    this.client = new BaseHttpClient(controller);
  }

  public async getJSON() {
    try {
      var result = await this.client.getAsync<any>("JSON");
      return result;
    } catch (error) {
      throw error;
    }
  }

  public async generateJSON() {
    try {
      var result = await this.client.getAsync<any>("GenerateJson");
      return result;
    } catch (error) {
      throw error;
    }
  }
  public async getAll() {
    try {
      var result = await this.client.getAsync<any>();
      return result;
    } catch (error) {
      throw error;
    }
  }
}
